// extracted by mini-css-extract-plugin
export default {"map":"SelectHiddenMap--map--5FTf2"};